/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import { withTranslation } from 'react-i18next'
import CardUnit from './cardUnit'
import {AiOutlineRight} from 'react-icons/ai'


function StatisticsItem(props) {

    return (
        <div className={"card " + props.className}>
            <a href="/pte/user_center/study_center?type=study">
                <div className="header p-3">
                    {props.data.header.name}
                    <p className="m-0">{props.data.header.btn}</p>
                </div>
                <div className="body p-3">
                    {
                        props.data.body.map((d) => (
                            <CardUnit 
                                title = {d.title}
                                des = {d.des}
                            />
                        ))
                    }
                </div>
                <div className="footer p-3">
                    {props.data.footer}
                    <AiOutlineRight />
                </div>
            </a>
        </div>
    )
}

export default withTranslation()(StatisticsItem)